/* eslint-disable no-console */
import React from 'react'
import { createRoot } from 'react-dom/client'

// Must run before App → AppType freezes APP_SLUG from localStorage
import './dev/applyAdminPreviewQuery'
import { applyLayoutModeFromLocation } from './lib/layoutMode'

applyLayoutModeFromLocation()

import App from './App'
import { logRestApiStartup } from './config/environment'
import { initializeI18n } from './i18n'
import './assets/style/index.scss'

logRestApiStartup()

const container = document.getElementById('root')
const root = createRoot(container!)

void initializeI18n().then(() => {
  root.render(<App />)
})
